import type { UseI18n } from '../core/i18n/useI18n'

function translatedOrFallback(t: UseI18n['t'], key: string, fallback: string): string {
  const translated = t(key)
  return translated === key ? fallback : translated
}

/** Os códigos são estáveis; os rótulos enviados pela API são apenas fallback. */
export const permissionModuleLabel = (t: UseI18n['t'], key: string, fallback: string) =>
  translatedOrFallback(t, `permissions.module.${key}`, fallback)

export const permissionLabel = (t: UseI18n['t'], key: string, fallback: string) =>
  translatedOrFallback(t, `permissions.item.${key}`, fallback)
